<script lang="ts">
    import {onDestroy, onMount} from 'svelte'
    import {tns} from 'tiny-slider/src/tiny-slider'
    import background from './background.png'
    import arrowLeft from './left.svg'
    import arrowRight from './right.svg'

    let slider
    let roadmapSlider
    let arrowTop
    let arrowBottom
    let displayedItems = 8
    let initIndex = 14
    let currentIndex = initIndex
    let lastIndex = 23

    if (window.innerWidth >= 1400) {
        displayedItems = 8
        initIndex = 28
    } else if (window.innerWidth >= 1200) {
        displayedItems = 7
        initIndex = 30
    } else if (window.innerWidth >= 992) {
        displayedItems = 6
        initIndex = 30
    } else if (window.innerWidth >= 768) {
        displayedItems = 4
        initIndex = 32
    } else {
        displayedItems = 2
        initIndex = 32
    }

    function slideChanged(info, eventName) {
        currentIndex = info.index
    }

    onMount(() => {
        slider = tns({
            container: roadmapSlider,
            nav: false,
            items: displayedItems,
            slideBy: 2,
            autoplay: false,
            axis: 'horizontal',
            prevButton: arrowTop,
            nextButton: arrowBottom,
            touch: true,
            speed: 600,
            loop: false,
            startIndex: initIndex,
            freezable: false,
        })

        slider.events.on('indexChanged', slideChanged)
    })

    onDestroy(() => {
        if (slider) {
            slider.events.off('indexChanged', slideChanged)
        }
    })
</script>

<section class="roadmap" id="roadmap">
    <div class="background" style="--Background:url({background});"></div>
    <div class="container">
        <div class="intro-title">Roadmap
            <div class="navigations">
                <div bind:this={arrowTop} class="arrow arrow-prev" class:disabled={currentIndex === 0}>
                    <img src="{arrowLeft}" alt="">
                </div>
                <div bind:this={arrowBottom} class="arrow arrow-next" class:disabled={currentIndex+displayedItems === lastIndex}>
                    <img src="{arrowRight}" alt="">
                </div>
            </div>
        </div>
        <div class="roadmap-wrapper">
            <div bind:this={roadmapSlider} class="roadmap-slider">
                <div class="slide">
                    <div class="year"><div>2018</div></div>
                </div>
                <div class="slide">
                    <div class="month">April</div>
                    <div class="dot"></div>
                    <div class="text">Crypto Cats<br>launch</div>
                </div>
                <div class="slide">
                    <div class="year"><div>2020</div></div>
                </div>
                <div class="slide">
                    <div class="month">September</div>
                    <div class="dot"></div>
                    <div class="text">Crypto Dragons<br>launch</div>
                </div>
                <div class="slide">
                    <div class="year"><div>2021</div></div>
                </div>
                <div class="slide">
                    <div class="month">January</div>
                    <div class="dot"></div>
                    <div class="text">Realis founded</div>
                </div>
                <div class="slide">
                    <div class="month">February</div>
                    <div class="dot"></div>
                    <div class="text">Legends of Listeria open test launch</div>
                </div>
                <div class="slide">
                    <div class="month">February</div>
                    <div class="dot"></div>
                    <div class="text">Testnet Blockchain launch</div>
                </div>
                <div class="slide">
                    <div class="year"><div>2022</div></div>
                </div>
                <div class="slide">
                    <div class="month">June</div>
                    <div class="dot"></div>
                    <div class="text">Microservice architecture</div>
                </div>
                <div class="slide">
                    <div class="month">August</div>
                    <div class="dot"></div>
                    <div class="text">Moved to NEAR protocol contract testnet</div>
                </div>
                <div class="slide">
                    <div class="month">November</div>
                    <div class="dot"></div>
                    <div class="text">Certik audit</div>
                </div>
                <div class="slide">
                    <div class="month">December</div>
                    <div class="dot"></div>
                    <div class="text">Staking $LIS</div>
                </div>
                <div class="slide">
                    <div class="month">December</div>
                    <div class="dot"></div>
                    <div class="text">NFT Marketplace launch on testnet</div>
                </div>
                <div class="slide">
                    <div class="month">December</div>
                    <div class="dot"></div>
                    <div class="text">Start of development of a new game (NFT Battler)</div>
                </div>
                <div class="slide">
                    <div class="year"><div>2023</div></div>
                </div>
                <div class="slide">
                    <div class="month">February</div>
                    <div class="dot"></div>
                    <div class="text">Bybit listing</div>
                </div>
                <div class="slide">
                    <div class="month">April</div>
                    <div class="dot"></div>
                    <div class="text">Realis Wallet<br>App</div>
                </div>
                <div class="slide">
                    <div class="month">April</div>
                    <div class="dot"></div>
                    <div class="text">Crypto Fox<br>launch</div>
                </div>
                <div class="slide">
                    <div class="month">June</div>
                    <div class="dot"></div>
                    <div class="text">NFT Marketplace<br>mainnet</div>
                </div>
                <div class="slide">
                    <div class="month">June</div>
                    <div class="dot"></div>
                    <div class="text">NFT battler<br>(MVP)</div>
                </div>
                <div class="slide">
                    <div class="month">July</div>
                    <div class="dot"></div>
                    <div class="text">Elemental Wars<br>(Beta)</div>
                </div>
                <div class="slide">
                    <div class="month">August</div>
                    <div class="dot"></div>
                    <div class="text">Crypto DOGE<br>launch</div>
                </div>
                <div class="slide">
                    <div class="month">September</div>
                    <div class="dot"></div>
                    <div class="text">Daily Streaks</div>
                </div>
                <div class="slide">
                    <div class="month">November</div>
                    <div class="dot"></div>
                    <div class="text">Leagues<br>integration</div>
                </div>
                <div class="slide">
                    <div class="year"><div>2024</div></div>
                </div>
                <div class="slide">
                    <div class="month">February</div>
                    <div class="dot"></div>
                    <div class="text">Elemental Wars<br>(Alpha)</div>
                </div>
                <div class="slide">
                    <div class="month">February</div>
                    <div class="dot"></div>
                    <div class="text">Elon Game<br>launch</div>
                </div>
                <div class="slide">
                    <div class="month">March</div>
                    <div class="dot"></div>
                    <div class="text">Ranking<br>Battles</div>
                </div>
                <div class="slide">
                    <div class="month">April</div>
                    <div class="dot"></div>
                    <div class="text">Community<br>Quests</div>
                </div>
                <div class="slide">
                    <div class="month">May</div>
                    <div class="dot"></div>
                    <div class="text">New Skills</div>
                </div>
                <div class="slide">
                    <div class="month">August</div>
                    <div class="dot"></div>
                    <div class="text">Crypto Frepe<br>launch</div>
                </div>
                <div class="slide">
                    <div class="year"><div>2025</div></div>
                </div>
                <div class="slide">
                    <div class="month"></div>
                    <div class="dot"></div>
                    <div class="text">Slots</div>
                </div>
                <div class="slide">
                    <div class="month"></div>
                    <div class="dot"></div>
                    <div class="text">New Economy</div>
                </div>
                <div class="slide">
                    <div class="month"></div>
                    <div class="dot"></div>
                    <div class="text">Elemental Wars<br>Relaunch</div>
                </div>
            </div>
        </div>
    </div>
</section>

<style lang="postcss">
    .roadmap {
        :global {
            @import "./tiny-slider.css";
        }
    }

    .roadmap {
        margin: 100px 0 0;
        padding-top: 100px;
        position: relative;
        z-index: 3;
    }

    .container {
        position: relative;
    }

    .background {
        background: linear-gradient(220deg, rgba(87, 97, 215, 0.2) 23%, rgba(87, 97, 215, 0.14) 50%);
        background: var(--Background) no-repeat center;
        height: 872px;
        width: 100%;
        position: absolute;
        left: 0;
        top: -50%;
        margin-top: -35px;
    }

    .intro-title {
        font-family: 'Anton', sans-serif;
        font-size: 70px;
        font-weight: 400;
        color: white;
        margin: 0 0 30px;
        line-height: 1.5;
        letter-spacing: 3px;
        position: relative;
        text-align: center;
    }

    .intro-title span {
        color: transparent;
        -webkit-text-stroke: 1px white;
    }

    .navigations {
        position: absolute;
        right: 0;
        top: 0;
        display: flex;
        align-items: center;
        height: 100%;
    }

    .arrow {
        width: 50px;
        height: 50px;
        border: 2px solid #A0AEC0;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        transition: .25s;
        user-select: none;
    }

    .arrow img {
        transition: .25s;
    }

    .arrow-next {
        margin-left: 10px;
    }

    .arrow:not(.disabled):hover {
        border-color: white;
        background: white;
    }

    .arrow:not(.disabled):hover img {
        filter: brightness(0);
    }

    .arrow.disabled {
        opacity: 0.7;
        cursor: default;
    }

    .roadmap-wrapper {
        display: flex;
        justify-content: space-between;
        margin: 40px 0 0;
        position: relative;
    }

    .slide {
        text-align: center;
        line-height: 1;
        position: relative;
        float: left;
        margin-top: 40px;
    }

    .month {
        font-family: 'Anton', sans-serif;
        text-transform: uppercase;
        font-size: 25px;
        color: white;
    }

    .dot {
        width: 30px;
        height: 30px;
        background: #7C83E5;
        box-shadow: 0 0 20px rgba(201, 203, 255, 0.5), inset 0 4px 4px rgba(0, 0, 0, 0.25);
        border-radius: 50%;
        position: relative;
        margin: 20px auto;
    }

    .slide:before {
        content: "";
        width: 100%;
        position: absolute;
        background: #2F2F4C;
        height: 3px;
        left: 0;
        top: 58px;
    }

    .dot:after {
        content: "";
        width: 16px;
        height: 16px;
        background: white;
        position: absolute;
        border-radius: 50%;
        left: 50%;
        top: 50%;
        margin: -8px 0 0 -8px;
        box-shadow: 0 0 70px rgba(170, 173, 248, 0.23);
    }

    .year {
        color: #979CF0;
        font-family: 'Anton', sans-serif;
        font-size: 50px;
        text-transform: uppercase;
        line-height: 1;
        margin-top: -35px;
        display: block;
    }

    .year div {
        display: initial;
        margin: 0 auto;
        position: relative;
    }

    .year div:after {
        content: "";
        width: 100%;
        height: 75px;
        background: linear-gradient(180deg, rgba(170, 173, 248, 0) 0%, rgba(145, 162, 250, 0.2) 100%);
        position: absolute;
        top: 34px;
        left: 0;
        border-bottom: 3px solid #4C5080;
    }

    .text {
        font-size: 14px;
        color: #91A2FA;
        line-height: 21px;
    }

    @media(max-width: 1199px) {
        .intro-title {
            font-size: 50px;
            line-height: 1.3;
        }

        .background {
            width: 100vw;
        }

        .roadmap {
            margin: 200px 0 0;
            padding-top: 0;
        }
    }

    @media(max-width: 767px) {
        .intro-title {
            font-size: 40px;
            margin-bottom: 30px;
            text-align: left;
        }

        .roadmap {
            margin: 30px 0 0;
            padding-top: 70px;
        }
    }
</style>
